/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import Thumbnail from '@base/Thumbnail/Thumbnail';
import Link from '@base/Link/Link';
import P2 from '@base/P2/P2';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import analyticsAction from '@actions/analytics';
import useWindowSize from '@hooks/useWindowSize';
import { TextColors, BgColors } from '@styles/index';
import CardCarousel from './CardCarousel';

const SecWrapper = styled.section`
  position: relative;
  margin: auto;
  margin-top: 195px;
  padding-bottom: 32px;
  width: 1376px;
  overflow: hidden;
  @media (max-width: 70.95em) {
    width: 728px;
    margin-top: 96px;
  }
  @media (max-width: 47.95em) {
    width: 100%;
    margin: 88px 0 0;
    padding-bottom: 0;
  }
`;

const CardContainer = styled.div`
  width: 480px;
  height: 228px;
  margin-right: 24px;
  cursor: pointer;
  position: relative;
  @media (max-width: 70.95em) {
    width: 272px;
    height: 300px;
    margin-top: 32px;
  }
  @media (max-width: 47.95em) {
    margin-right: 16px;
  }
`;

const CardWrapper = styled.div`
  width: 440px;
  height: inherit;
  padding: 24px;
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  border-radius: 8px;
  margin-left: 40px;
  position: relative;
  padding-left: 124px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${BgColors.WHITE};
  @media (max-width: 70.95em) {
    width: 272px;
    padding: 95px 16px 24px 16px;
    margin-left: 0;
    box-shadow: 0px 16px 32px #f0f4f7;
  }
`;

const CardThumbnail = styled(Thumbnail)`
  &.thumbnail {
    position: absolute;
    z-index: 1;
    background-size: cover;
    object-fit: cover;
    border-radius: 8px;
    @media (min-width: 70.95em) {
      width: 140px;
      height: 180px;
      left: 0;
      top: 24px;
      box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
    }
    @media (max-width: 70.95em) {
      width: 103px;
      height: 103px;
      top: -32px;
      left: 16px;
      box-shadow: none;
    }
  }
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Description = styled(P1)`
  flex-grow: 1;
  margin-top: 12px;
`;

const Topics = styled(P2)`
  color: ${TextColors.BLUE};
`;

const Title = styled(H3)`
  @media only screen and (max-width: 47.95em) {
    font-size: 18px;
  }
`;

const Card = ({ educator, dataAnalytics, index, isMobile }) => {
  const { username, thumbnail, name, description, topicsDisplay } = educator;
  const dispatch = useDispatch();
  const cardClickAnalytics = (e) => {
    if (isMobile) {
      e.preventDefault();
      return window.open(`/@${username}`, '_self');
    }
    dispatch(
      analyticsAction(dataAnalytics, '', educator, {
        index,
        'Last Primary Source': 'goal page',
        'Last Primary Source Section': 'Prepare with Top Educators'
      })
    );
  };
  return (
    <Link href="/[authorID]" as={`/@${username}`} onClick={cardClickAnalytics}>
      <CardContainer>
        <CardThumbnail
          imgUrl={thumbnail}
          orientation="vertical"
          data-analytics={dataAnalytics}
          className="thumbnail"
        />
        <CardWrapper>
          <TopContent>
            <Title>{name}</Title>
            <Description>{description}</Description>
          </TopContent>
          <Topics>{topicsDisplay}</Topics>
        </CardWrapper>
      </CardContainer>
    </Link>
  );
};

const PageHead = ({ block, countryName, href, as }) => {
  const { users } = block;
  const { isMobile } = useWindowSize();
  return (
    <SecWrapper>
      <CardCarousel
        label="Prepare with Top Educators"
        subLabel={`Access to ${countryName}'s best educators is just a subscription away`}
        step={2}
        href={href}
        as={as}
        dataAnalytics="educators"
        type="educators"
      >
        {users.map((user, index) => (
          <Card
            isMobile={isMobile}
            key={user.uid}
            educator={user}
            index={index}
            dataAnalytics="subscription-educatorsCard"
          />
        ))}
      </CardCarousel>
    </SecWrapper>
  );
};

export default PageHead;
